import { ListItemIcon, MenuItem } from '@mui/material';
import { useState } from 'react';
import { useListContext,useUnselectAll } from 'react-admin';
import { BIN_ICON, PENDING_ICON, TICK_ICON_FILLED } from '../../utils/Constants/ClassName';
import { InputPicker } from 'rsuite';
import { PropayBulkActionModal } from './PropayBulkActionModal';
import { PROPAY_BULK_OPTIONS } from '../../utils/Constants/ConstantData';
import { useIdentityContext } from '../../components/identity';

const PropayBulkAction = props => {
    const { selectedIds = [] } = useListContext();
    const [selectedValue, setSelectedValue] = useState(null);
    const [showmodal, setShowModal] = useState(false);
    const unselectAll = useUnselectAll();
    const identity = useIdentityContext();


    const handleChange = value => {
        setSelectedValue(value);
        setShowModal(true);
    };
    const renderMenuItem = (label, item) => {
        return (
            <MenuItem className={item.class}>
                <ListItemIcon>{item.icon}</ListItemIcon> {item.label}{' '}
            </MenuItem>
        );
    };
    const handleClose = ()=>{
        setShowModal(false);
        setSelectedValue(null);
    }
    const bulkActionOptions = PROPAY_BULK_OPTIONS.map((item) => (item.value === 'Pending' && identity?.company?.is_started_status) ? {...item, label:'Pending or Start'}: item).filter((item) => (item.value === 'Complete' && !identity?.company?.is_completed_status) ? false : true)
    return (
        <>
            <div className="close-statement-toolbar">
                <span>{selectedIds.length} ProPays Selected </span>
                <InputPicker
                value={selectedValue}
                    placeholder="Bulk Action"
                    data={bulkActionOptions}
                    onSelect={value => handleChange(value)}
                    renderMenuItem={renderMenuItem}
                    placement="autoVerticalStart"
                    className='bulk-action-rs-picker-input'
                    menuClassName='bulk-action-dropdown'
                />
            </div>
            <PropayBulkActionModal
                isOpen={showmodal}
                action={selectedValue}
                selectedIds={selectedIds}
                onClose={() => handleClose()}
                unselectAll={unselectAll}
            ></PropayBulkActionModal>
        </>
    );
};

export default PropayBulkAction;
